var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUpStrikethru({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 22 22",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.67 7.83C16.5 7.83 15.65 7.83 14.11 7.83C14.13 7.79 14.13 7.77 14.14 7.77C14.16 7.7 14.22 7.53 14.29 7.36C14.29 7.36 14.29 7.36 14.29 7.36C14.29 7.36 14.29 7.36 14.29 7.36C14.34 7.21 14.4 7.07 14.42 7.01C14.58 6.59 14.7 6.24 14.79 5.9C14.93 5.39 15.01 4.93 15.01 4.5C15.01 3.27 14.25 2.51 13.13 2.18C12.63 2.03 12.19 2 11.67 2C11.65 2 11.51 2 11.27 2C11.12 2.18 11.04 2.29 11.02 2.31C10.74 2.66 10.19 3.29 9.55 4.03C9.55 4.03 9.55 4.03 9.55 4.03C9.55 4.03 9.55 4.03 9.55 4.03C8.37 5.37 6.9 7.05 6.32 7.9C6.16 7.85 6.01 7.83 5.84 7.83C5.67 7.83 4.34 7.83 4.17 7.83C3.25 7.83 2.51 8.58 2.51 9.5C2.51 10.25 2.51 16.25 2.51 17C2.51 17.92 3.25 18.66 4.17 18.66C4.34 18.66 5.67 18.66 5.84 18.66C6.41 18.66 6.92 18.37 7.22 17.93C7.47 18.1 7.75 18.23 8.06 18.34C8.76 18.6 9.46 18.67 10.04 18.66C10.62 18.66 15.26 18.66 15.84 18.66C18.14 18.66 19.17 15.28 19.17 10.33C19.17 8.93 18.23 7.83 16.67 7.83ZM7.51 15.33C7.51 14.94 7.51 13 7.51 9.5C7.51 9.5 7.51 9.5 7.51 9.5C7.51 9.3 7.54 9.12 7.62 8.93C7.77 8.59 9.09 7.08 10.34 5.65C10.34 5.65 10.34 5.65 10.34 5.65L10.34 5.65L10.34 5.65C10.34 5.65 10.34 5.65 10.34 5.65C10.99 4.92 11.62 4.2 12.06 3.68C12.27 3.69 12.46 3.72 12.66 3.78C13.14 3.92 13.34 4.12 13.34 4.5C13.34 4.76 13.29 5.08 13.18 5.46C13.1 5.75 13 6.05 12.86 6.43C12.84 6.48 12.79 6.62 12.73 6.76C12.73 6.76 12.73 6.76 12.73 6.76C12.73 6.76 12.73 6.76 12.73 6.76C12.67 6.93 12.6 7.12 12.57 7.19C12.46 7.48 12.39 7.7 12.34 7.89C12.14 8.73 12.34 9.5 13.34 9.5C13.67 9.5 16.34 9.5 16.67 9.5C17.25 9.5 17.51 9.8 17.51 10.33C17.51 14.32 16.69 17 15.84 17C15.45 17 13.51 17 10.01 17C9.99 17 9.98 17 9.98 17C9.61 17 9.1 16.95 8.62 16.78C7.88 16.51 7.51 16.08 7.51 15.33ZM4.17 9.5L5.84 9.5L5.84 17L4.17 17L4.17 9.5Z",
    id: "c2id1YaHJf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.46L22 11.46",
    id: "a10QQpehYZ"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2id1YaHJf",
    opacity: 1,
    fill: "#666666",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2id1YaHJf",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a10QQpehYZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#272727",
    strokeWidth: 1.5,
    strokeOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpStrikethru);
export default __webpack_public_path__ + "static/media/thumbs-up-strikethru.edee0fd28191ccdbdd80fb5014127271.svg";
export { ForwardRef as ReactComponent };